/* UpFone theme - vanilla JS only, no framework. */
(function () {
  'use strict';

  // --- Reveal on scroll ---
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-in'));
  }

  // --- Product gallery ---
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main] img');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.src;
        const alt = thumb.dataset.alt || '';
        if (main && src) {
          main.src = src;
          main.alt = alt;
        }
        thumbs.forEach((t) => t.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  // --- Variant selector ---
  document.querySelectorAll('[data-variant-form]').forEach((form) => {
    // Read variants from the <script type="application/json"> block (more robust than HTML attribute)
    const jsonScript = document.querySelector('[data-product-json]');
    let variants = [];
    if (jsonScript) {
      try {
        variants = JSON.parse(jsonScript.textContent.trim());
      } catch (e) {
        console.error('UpFone: variant JSON parse failed', e);
        return;
      }
    }
    if (!Array.isArray(variants) || variants.length === 0) {
      console.warn('UpFone: no variants found');
      return;
    }

    // Use document-scoped selectors because price/gallery sit OUTSIDE the form
    const variantInput = form.querySelector('[name="id"]');
    const priceEl = document.querySelector('[data-price]');
    const neupreisEl = document.querySelector('[data-neupreis]');
    const neupreisValueEl = document.querySelector('[data-neupreis-value]');
    let neupreisByVariant = {};
    try {
      const neupreisJson = document.querySelector('[data-neupreis-json]');
      if (neupreisJson) neupreisByVariant = JSON.parse(neupreisJson.textContent);
    } catch (e) {
      console.warn('UpFone: Neupreis-Daten nicht lesbar', e);
    }
    const submitBtn = form.querySelector('[data-buy-btn]');
    const conditionInfo = form.querySelector('[data-condition-info]');
    const gallery = document.querySelector('[data-gallery]');
    const galleryMain = gallery ? gallery.querySelector('[data-gallery-main] img') : null;
    const galleryMainBox = gallery ? gallery.querySelector('[data-gallery-main]') : null;
    const galleryThumbs = gallery ? gallery.querySelectorAll('[data-gallery-thumb]') : [];

    function selectedValues() {
      return Array.from(form.querySelectorAll('input[data-option-index]:checked')).map(
        (i) => ({ index: parseInt(i.dataset.optionIndex, 10), value: i.value })
      );
    }

    function findVariant() {
      const selected = selectedValues();
      if (selected.length === 0) return null;
      return variants.find((v) =>
        selected.every((s) => v.options[s.index] === s.value)
      );
    }

    function formatMoney(cents) {
      const v = (cents / 100).toFixed(2).replace('.', ',');
      return v + ' €';
    }

    function withWidth(url, width) {
      if (!url) return url;
      // Strip any existing width param and add a fresh one
      const sep = url.indexOf('?') >= 0 ? '&' : '?';
      const cleaned = url.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
      const sep2 = cleaned.indexOf('?') >= 0 ? '&' : '?';
      return cleaned + sep2 + 'width=' + width;
    }

    // Cache preloaded images so subsequent swaps to the same color are instant
    const imageCache = new Map();

    function preloadImage(src) {
      if (imageCache.has(src)) return imageCache.get(src);
      const promise = new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(src);
        img.onerror = reject;
        img.src = src;
      });
      imageCache.set(src, promise);
      return promise;
    }

    let swapToken = 0;
    function swapImage(variant) {
      if (!variant || !variant.featured_image || !galleryMain || !galleryMainBox) return;
      const src = variant.featured_image.src || variant.featured_image;
      const alt = (variant.featured_image.alt) || variant.title || '';
      if (!src) return;
      const fullSrc = withWidth(src, 1400);

      // If already showing this image, no-op
      if (galleryMain.src === fullSrc || galleryMain.currentSrc === fullSrc) {
        return;
      }

      // Show loading state
      const myToken = ++swapToken;
      galleryMainBox.classList.add('is-loading');

      preloadImage(fullSrc).then(() => {
        // Only swap if no newer swap happened in the meantime
        if (myToken !== swapToken) return;
        galleryMain.src = fullSrc;
        galleryMain.alt = alt;
        // Tiny fade-in
        galleryMain.classList.add('is-fading-in');
        requestAnimationFrame(() => {
          galleryMainBox.classList.remove('is-loading');
          requestAnimationFrame(() => {
            galleryMain.classList.remove('is-fading-in');
          });
        });
      }).catch(() => {
        if (myToken === swapToken) {
          galleryMainBox.classList.remove('is-loading');
        }
      });

      // Sync thumb aria-current
      const targetId = (variant.featured_image && variant.featured_image.id)
        || (variant.featured_media && variant.featured_media.id);
      if (targetId && galleryThumbs.length) {
        galleryThumbs.forEach((t) => {
          const tid = t.getAttribute('data-media-id');
          t.setAttribute('aria-current', String(tid) === String(targetId) ? 'true' : 'false');
        });
      }
    }

    function updateUI() {
      const variant = findVariant();
      const selected = selectedValues();

      // visual checked state on pills
      form.querySelectorAll('.option-pill').forEach((pill) => {
        const input = pill.querySelector('input');
        if (input) pill.dataset.checked = input.checked ? 'true' : 'false';
      });

      if (!variant) {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Nicht verfügbar';
        }
        return;
      }

      // Update variant ID, price, button state, image
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      // Früherer Neupreis (Metafeld custom.neupreis) als reine Info, kein Streichpreis
      if (neupreisEl && neupreisValueEl) {
        const neupreis = neupreisByVariant[String(variant.id)];
        neupreisValueEl.textContent = neupreis || '';
        neupreisEl.hidden = !neupreis;
      }

      if (submitBtn) {
        if (variant.available) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.labelAvailable || 'In den Warenkorb';
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = submitBtn.dataset.labelSoldOut || 'Ausverkauft';
        }
      }

      // Swap main gallery image to variant's assigned image (if any)
      swapImage(variant);

      // Condition info panel
      if (conditionInfo) {
        const condition = selected.find((s) => s.index === parseInt(conditionInfo.dataset.optionIndex, 10));
        if (condition) {
          conditionInfo.querySelectorAll('[data-condition-value]').forEach((p) => (p.hidden = true));
          const panel = conditionInfo.querySelector('[data-condition-value="' + condition.value + '"]');
          if (panel) panel.hidden = false;
        }
      }

      // Update URL with ?variant=ID (preserves deeplinks/share)
      try {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } catch (e) {}
    }

    // --- Availability helpers ---
    function setRadio(index, value) {
      form.querySelectorAll('input[data-option-index="' + index + '"]').forEach((r) => {
        if (r.value === value) r.checked = true;
      });
    }

    // A value is "dead" only if NO available variant anywhere uses it
    function valueHasAvailable(index, value) {
      return variants.some((v) => v.options[index] === value && v.available);
    }

    // Grey out / disable values that have no available variant at all
    function refreshAvailability() {
      form.querySelectorAll('input[data-option-index]').forEach((input) => {
        const idx = parseInt(input.dataset.optionIndex, 10);
        const ok = valueHasAvailable(idx, input.value);
        const pill = input.closest('.option-pill');
        input.disabled = !ok && !input.checked;
        if (pill) pill.dataset.soldout = ok ? 'false' : 'true';
      });
    }

    // When one option changes, snap the OTHER options to an available combo,
    // keeping as many of the user's current selections as possible.
    function snapToAvailable(changedIndex, changedValue) {
      const current = selectedValues();
      const pool = variants.filter((v) => v.options[changedIndex] === changedValue && v.available);
      if (pool.length === 0) return; // value fully sold out → leave as-is (button shows sold out)
      let best = null, bestScore = -1;
      pool.forEach((v) => {
        let score = 0;
        current.forEach((s) => {
          if (s.index !== changedIndex && v.options[s.index] === s.value) score++;
        });
        if (score > bestScore) { bestScore = score; best = v; }
      });
      if (best) best.options.forEach((val, idx) => setRadio(idx, val));
    }

    form.querySelectorAll('input[data-option-index]').forEach((input) => {
      input.addEventListener('change', (e) => {
        const idx = parseInt(e.target.dataset.optionIndex, 10);
        snapToAvailable(idx, e.target.value);
        updateUI();
        refreshAvailability();
      });
    });
    updateUI();
    refreshAvailability();
  });

  // --- Quantity steppers ---
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    if (!input) return;
    const upBtn = wrap.querySelector('[data-qty-up]');
    const getMax = () => (input.max !== '' && input.max != null ? parseInt(input.max, 10) : Infinity);
    function syncUp() {
      if (upBtn) upBtn.disabled = parseInt(input.value || 1, 10) >= getMax();
    }
    wrap.querySelector('[data-qty-down]')?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value || 1, 10) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    upBtn?.addEventListener('click', () => {
      const next = parseInt(input.value || 1, 10) + 1;
      input.value = Math.min(next, getMax());
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    // Clamp manual typing to the available stock
    input.addEventListener('change', () => {
      let v = parseInt(input.value || 1, 10);
      if (isNaN(v) || v < 0) v = 1;
      const max = getMax();
      if (v > max) v = max;
      input.value = v;
      syncUp();
    });
    syncUp();
  });
})();

